import React, { useEffect, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getProject,
  getIssues,
  getIssueFields,
  dropDownSearchJiraProjects,
  searchJiraProjects,
} from '../skills_action';
import { Select, Typography } from 'antd';
import {
  getAllLabelsInTheDomain,
  /* getAllResolutionsInTheDomain, */ getAllUsersInTheDomain,
  getAllStatusesInTheDomain,
} from '../skills_action';
const { Option } = Select;
const { Text } = Typography;
// const location = useLocation()

function JiraCommonIssueFields(props) {
  const {
    match: {
      params: { wId },
    },
    handleUpdateFieldDefaultsChanges,
    selectedActionForUpadate,
    selectedCommand,
    forCommands,
    projects,
    issues,
    skills,
    linkedProject,
  } = props;

  const jiraSkill = skills.find((skill) => skill.key === 'jira');
  let selectedCommandForUpdate =
    selectedCommand && selectedCommand.filter
      ? selectedCommand.filter
      : {
          customFields: {
            reporter: [],
            assignee: [],
            status: [],
            selectedProjects: [],
            selectedIssues: [],
          },
        };

  const [labels, set_labels] = useState([]);
  const [labelsLoading, set_labelsLoading] = useState(false);
  const [resolutions, set_resolutions] = useState([]);
  const [jiraUsers, set_jiraUsers] = useState([]);
  const [statuses, set_statuses] = useState([]);
  const [selectedLabels, set_selectedLabels] = useState([]);
  const [selectedResolution, set_selectedResolution] = useState(null);
  const [selectedAssignee, set_selectedAssignee] = useState(
    forCommands ? [] : null
  );
  const [selectedStatus, set_selectedStatus] = useState(
    forCommands ? [] : null
  );
  const [selectedReporter, set_selectedReporter] = useState(
    forCommands ? [] : null
  );

  const [selectedProjects, setSelectedProjects] = useState(null);
  const [selectedIssues, setSelectedIssues] = useState(null);
  const [allIssues, setAllIssues] = useState([]);

  // const[handleData, setHandleData]= useState({});

  useEffect(() => {
    set_labelsLoading(true);
    getAllLabelsInTheDomain(wId).then((res) => {
      if (res.success) {
        set_labelsLoading(false);
        set_labels(res.labels);
      }
    });
    // getAllResolutionsInTheDomain(wId).then((res) => {
    //   if (res.success) set_resolutions(res.resolutions);
    // });
    getAllUsersInTheDomain(wId).then((res) => {
      if (res.success) set_jiraUsers(res.jiraUsers);
    });

    getAllStatusesInTheDomain(wId).then((res) => {
      // if (res.success) set_statuses(res.statuses);
      if (res.success) filterStatuses(res.statuses);
    });

    getIssueFields(wId).then((res) => {
      const uniqueIssueTypes = [];
      if (res.data.success) {
        const unique = res.data.items.filter((issueType) => {
          const isDuplicate = uniqueIssueTypes.includes(issueType.name);
          if (!isDuplicate) {
            uniqueIssueTypes.push(issueType.name);
            return true;
          }
          return false;
        });
        setAllIssues(unique);
      }
    });
    updateState();

    return () => {
      // set_selectedLabels([]);
      // set_selectedReporter(forCommands?[]:null);
      // set_selectedAssignee(forCommands?[]:null);
      // set_selectedStatus(forCommands?[]:null);
      // setSelectedProjects([]);
      // setSelectedIssues([]);
      // labels  = []
      // selectedAssignee = []
      // selectedProjects = []
      // selectedStatus = []
    };
  }, []);

  useEffect(() => {
    updateState();
  }, [selectedActionForUpadate, selectedCommand]);

  useEffect(() => {
    let data = {};
    if (selectedLabels && selectedLabels.length > 0)
      data.labels = selectedLabels;
    if (selectedResolution) data.resolution = selectedResolution;
    if (selectedReporter) data.reporter = selectedReporter;
    if (selectedAssignee) data.assignee = selectedAssignee;
    if (selectedStatus) data.status = selectedStatus;
    if (selectedProjects) data.selectedProjects = selectedProjects;
    if (selectedIssues) data.selectedIssues = selectedIssues;

    handleUpdateFieldDefaultsChanges(data);
    //  setHandleData(data)
  }, [
    selectedLabels,
    selectedResolution,
    selectedAssignee,
    selectedReporter,
    selectedStatus,
    selectedProjects,
    selectedIssues,
  ]);
  // console.log(selectedLabels, selectedResolution, selectedAssignee, selectedReporter, selectedStatus, selectedProjects, selectedIssues)
  // console.log(selectedCommandForUpdate)

  const updateState = () => {
    if (forCommands) {
      if (selectedCommandForUpdate) {
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.labels &&
        selectedCommandForUpdate.customFields.labels.length > 0
          ? set_selectedLabels(selectedCommandForUpdate.customFields.labels)
          : set_selectedLabels([]);
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.reporter &&
        selectedCommandForUpdate.customFields.reporter.length > 0
          ? set_selectedReporter(selectedCommandForUpdate.customFields.reporter)
          : set_selectedReporter([]);
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.assignee &&
        selectedCommandForUpdate.customFields.assignee.length > 0
          ? set_selectedAssignee(selectedCommandForUpdate.customFields.assignee)
          : set_selectedAssignee([]);
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.status &&
        selectedCommandForUpdate.customFields.status.length > 0
          ? set_selectedStatus(selectedCommandForUpdate.customFields.status)
          : set_selectedStatus([]);
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.selectedProjects &&
        selectedCommandForUpdate.customFields.selectedProjects.length > 0
          ? setSelectedProjects(
              selectedCommandForUpdate.customFields.selectedProjects
            )
          : setSelectedProjects([]);
        selectedCommandForUpdate.customFields &&
        selectedCommandForUpdate.customFields.selectedIssues &&
        selectedCommandForUpdate.customFields.selectedIssues.length > 0
          ? setSelectedIssues(
              selectedCommandForUpdate.customFields.selectedIssues
            )
          : setSelectedIssues([]);
      }
    } else {
      if (
        selectedActionForUpadate &&
        selectedActionForUpadate.arguments &&
        selectedActionForUpadate.arguments.fieldDefaults
      ) {
        if (selectedActionForUpadate.arguments.fieldDefaults.labels)
          set_selectedLabels(
            selectedActionForUpadate.arguments.fieldDefaults.labels
          );
        if (selectedActionForUpadate.arguments.fieldDefaults.resolution)
          set_selectedResolution(
            selectedActionForUpadate.arguments.fieldDefaults.resolution
          );
        if (selectedActionForUpadate.arguments.fieldDefaults.reporter)
          set_selectedReporter(
            selectedActionForUpadate.arguments.fieldDefaults.reporter
          );
        if (selectedActionForUpadate.arguments.fieldDefaults.assignee)
          set_selectedAssignee(
            selectedActionForUpadate.arguments.fieldDefaults.assignee
          );
        if (selectedActionForUpadate.arguments.fieldDefaults.status)
          set_selectedStatus(
            selectedActionForUpadate.arguments.fieldDefaults.status
          );
      }
    }
  };

  const filterStatuses = (statusesData) => {
    let statuses = [];
    statusesData.forEach((status) => {
      if (status.name !== 'Backlog' && !statuses.includes(status.name))
        statuses.push(status.name);
    });
    set_statuses(statuses);
  };

  const onSearch = (val) => {
    let timeout = 0;
    //  console.log("onSearch", val, props.currentSkill)
    // if (
    //   props.currentSkill &&
    //   props.currentSkill.metadata &&
    //   (props.currentSkill.metadata.server_type === "jira_cloud_oauth" || props.currentSkill.metadata.server_type === "jira_cloud") &&
    //   props.match.params.sub_skill !== "jira_service_desk"
    // ) {
    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      (jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud_oauth' ||
        jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud')
    ) {
      // console.log('onSearch', val)
      let query = `query=${val || ''}`;
      // const queryType = isGlobalProjectRestriction
      //   ? "&typeKey=software,business"
      //   : channel_type === "agent"
      //   ? "&typeKey=service_desk"
      //   : "&typeKey=software,business";
      // query = query + queryType;
      // if (isGlobalProjectRestriction ? true : channel_type === "project" || channel_type === "agent") {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        // console.log("timer")
        props.dropDownSearchJiraProjects(wId, `?query=${query}`);
        // console.log( props.dropDownSearchJiraProjects(wId, `?query=${query}`).then(res=>res))
      }, 300);
    }
  };

  const handleChange = ({ type, value, options }) => {
    let temp;
    //  console.log(options, value)
    // if (type === "switch") temp.projectRestrictionDisabled = !value;
    // if (type === "radio") temp.restriction_type = value;
    // else if (type === "select") {
    temp = options.map((o) => o.project);
    temp = temp.filter(function (element) {
      return element !== undefined;
    });
    // }
    // console.log(temp)
    forCommands ? setSelectedProjects(value) : setSelectedProjects(temp);
  };

  // console.log('selectedProject \n',selectedProjects);

  let children = projects
    .filter(
      (proj) =>
        proj.projectTypeKey === 'software' ||
        proj.projectTypeKey === 'business' ||
        proj.projectTypeKey === 'service_desk'
    )
    .map((d) => {
      // console.log(' DDDDDDDDDDDDDDDDDDDDDDD is  here \n', d)
      return (
        <Option
          key={d.key || d.projectKey}
          value={d.id || d.projectId}
          name={d.name || d.projectName}
          project={d}
        >
          {`${d.name || d.projectName} ${`(${d.key || d.projectKey})`}`}
        </Option>
      );
    });
  children = children.filter((child) => {
    return child;
  });

  // console.log(selectedAssignee, selectedReporter)
  return (
    <div
      style={{
        // height: 400,
        display: 'flex',
        flexDirection: 'column',
        // paddingRight: 16,
        // flexWrap: 'wrap',
      }}
    >
      {forCommands && (
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Choose project(s)
          </Text>
          <Select
            // style={{ width: "81%" }}
            mode='multiple'
            showSearch
            autoClearSearchValue
            placeholder='Select projects'
            onSearch={(val) => onSearch(val)}
            onChange={(value, options) =>
              handleChange({ type: 'select', value, options })
            }
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            value={
              forCommands
                ? selectedProjects
                  ? selectedProjects.map((p) => {
                      return p;
                    })
                  : null
                : selectedProjects
                ? selectedProjects.map((p) => p && (p.id || p.projectId))
                : null
            }
            // disabled={disabled}
            allowClear
            loading={projects && projects.length === 0}
          >
            {children}
          </Select>
        </div>
      )}
      {forCommands && (
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Choose issue type(s)
          </Text>
          <Select
            // style={{ width: 220 }}
            placeholder='Choose issue type(s)'
            mode='multiple'
            // defaultValue={}
            allowClear
            onChange={(value) => setSelectedIssues(value ? value : null)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            value={selectedIssues ? selectedIssues : null}
          >
            {allIssues &&
              allIssues.map((issue, index) => (
                <Option key={issue.name} value={issue.name}>
                  {issue.projectName
                    ? `${issue.name} (${issue.projectName})`
                    : issue.name}
                </Option>
              ))}
          </Select>
        </div>
      )}

      <div
        style={{
          marginBottom: 16,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Text type='secondary' strong>
          Set status
        </Text>
        <Select
          mode={forCommands && 'multiple'}
          allowClear
          placeholder='Set status'
          loading={statuses.length === 0}
          onChange={(value) => set_selectedStatus(value)}
          value={
            forCommands
              ? selectedStatus
                ? selectedStatus.map((status) => status)
                : null
              : selectedStatus
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          showSearch
        >
          {statuses.map((status) => (
            <Option key={status} value={status}>
              {status}
            </Option>
          ))}
        </Select>
      </div>
      {!linkedProject && (
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Assignee
          </Text>
          <Select
            allowClear
            mode={forCommands && 'multiple'}
            placeholder='Set assignee'
            loading={jiraUsers.length === 0}
            value={
              forCommands
                ? selectedAssignee
                  ? selectedAssignee.map((assignee) => assignee)
                  : []
                : selectedAssignee
                ? selectedAssignee === 'assign_to_action_taker'
                  ? selectedAssignee
                  : selectedAssignee.accountId || selectedAssignee.name
                : null
            }
            onChange={(value, data) => {
              set_selectedAssignee(
                forCommands
                  ? value
                    ? value
                    : null
                  : value === 'assign_to_action_taker'
                  ? value
                  : data && data.assignee
                  ? data.assignee
                  : null
              );
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {forCommands ? (
              ''
            ) : (
              <Option
                key={'assign_to_action_taker'}
                value={'assign_to_action_taker'}
              >
                Assign to action taker
              </Option>
            )}
            {jiraUsers.map((user) => (
              <Option
                key={user.accountId || user.name}
                value={user.accountId || user.name}
                assignee={user}
              >
                {user.displayName}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {!linkedProject && (
        <div
          style={{
            // marginRight: 16,
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Reporter
          </Text>
          <Select
            allowClear
            placeholder='Set reporter'
            mode={forCommands && 'multiple'}
            loading={jiraUsers.length === 0}
            value={
              forCommands
                ? selectedReporter
                  ? selectedReporter.map((reporter) => reporter)
                  : []
                : selectedReporter
                ? selectedReporter.accountId || selectedReporter.name
                : null
            }
            onChange={(value, data) => {
              set_selectedReporter(
                forCommands
                  ? value
                    ? value
                    : []
                  : data && data.reporter
                  ? data.reporter
                  : null
              );
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {jiraUsers.map((user) => (
              <Option
                key={user.accountId || user.name}
                value={user.accountId || user.name}
                reporter={user}
              >
                {user.displayName}
              </Option>
            ))}
          </Select>
        </div>
      )}
      {/* <div
        style={{
          marginBottom: 16,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text type='secondary' strong>
          Resolution
        </Text>
        <Select
          allowClear
          placeholder='Set resolution(s)'
          loading={resolutions.length === 0}
          onChange={(value, data) => set_selectedResolution(data && data.resolution ? data.resolution : null)}
          value={selectedResolution ? selectedResolution.id : null}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          showSearch
        >
          {resolutions.map((resolution) => (
            <Option key={resolution.id} value={resolution.id} resolution={resolution}>
              {resolution.name}
            </Option>
          ))}
        </Select>
      </div> */}
      {!linkedProject && (
        <div
          style={{
            marginBottom: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text type='secondary' strong>
            Label(s)
          </Text>
          <Select
            allowClear
            placeholder='Set Label(s)'
            mode='multiple'
            // loading={labels && labels.length === 0}
            loading={labelsLoading}
            onChange={(value) => set_selectedLabels(value)}
            onSearch={(data) => {
              if (
                (jiraSkill &&
                  jiraSkill.skill_metadata &&
                  jiraSkill.skill_metadata.metadata.server_type ==
                    'jira_server') ||
                jiraSkill.skill_metadata.metadata.server_type ==
                  'jira_server_oauth'
              ) {
                /* IN CASE OF SERVER THERE IS NO OFFICAL API, 
                WE ARE USING THE AUTOCOMPLETE URL TO GET THE LABELS, 
                THERE IS NO PAGINATION LOGIC IN SO WE ARE NOT SURE IF WE HAVE ALL THE LABELS, 
                SO WE ARE GETTING LABELS BASED ON SEARCH QUERY HERE 
                */
                getAllLabelsInTheDomain(wId, data).then((res) => {
                  if (res.success) {
                    set_labelsLoading(false);
                    set_labels(res.labels);
                  }
                });
              }
            }}
            onBlur={() => {
              if (
                (jiraSkill &&
                  jiraSkill.skill_metadata &&
                  jiraSkill.skill_metadata.metadata.server_type ==
                    'jira_server') ||
                jiraSkill.skill_metadata.metadata.server_type ==
                  'jira_server_oauth'
              ) {
                /* RESTING LABELS ARRAY IN CASE OF SERVER */
                getAllLabelsInTheDomain(wId).then((res) => {
                  if (res.success) {
                    set_labelsLoading(false);
                    set_labels(res.labels);
                  }
                });
              }
            }}
            value={selectedLabels}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showSearch
          >
            {labels &&
              labels.map((label) => (
                <Option key={label} value={label}>
                  {label}
                </Option>
              ))}
          </Select>
        </div>
      )}
      {/* <div
        style={{
          marginBottom: 16,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text>Set Fix version</Text>
        <Select
          allowClear
          // style={{ width: 220 }}
          placeholder='Set Fix version(s)'
          // mode="multiple"
          defaultValue={"1"}
        >
          <Option value='0'>Fix Version0</Option>
          <Option value='1'>Fix Version1</Option>
          <Option value='2'>Fix Version2</Option>
        </Select>
      </div>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text>Set Affects version</Text>
        <Select
          allowClear
          // style={{ width: 220 }}
          placeholder='Set affects version(s)'
          // mode="multiple"
          defaultValue={"1"}
        >
          <Option value='0'>Affects version0</Option>
          <Option value='1'>Affects version1</Option>
          <Option value='2'>Affects version2</Option>
        </Select>
      </div> */}
      {/* <div
        style={{
          marginBottom: 48,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text>Set Sprint</Text>
        <Select
          allowClear
          // style={{ width: 220 }}
          placeholder='Set sprint(s)'
          // mode="multiple"
          defaultValue={"1"}
        >
          <Option value='0'>Sprint0</Option>
          <Option value='1'>Sprint1</Option>
          <Option value='2'>Sprint2</Option>
        </Select>
      </div> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    isAdmin: state.common_reducer.isAdmin,
    projects: state.skills.projects,
    issues: state.skills.issues,
    skills: state.skills.skills,
    team: state.skills.team,

    user_now: state.common_reducer.user,
    currentSkill: state.skills.currentSkill,
    jiraSkill: state.skills.skills
      ? state.skills.skills.find((skill) => skill.key === 'jira')
      : null,
  };
};
// export default withRouter(JiraCommonIssueFields);
export default withRouter(
  connect(mapStateToProps, {
    getProject,
    getIssues,
    dropDownSearchJiraProjects,
    searchJiraProjects,
  })(JiraCommonIssueFields)
);
